import { AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { getNgClassInputAsString } from '@panaya/utils';

@Directive({
    selector: '[matTooltip]'
})
export class PTooltipDirective implements AfterViewInit {
    private _disableTooltip = false;

    @Input() showOnlyWhenEllipsis = false;

    @Input() set disableTooltip(value: boolean) {
        this._disableTooltip = value;
        this.matTooltip.disabled = this._disableTooltip;
    }

    private readonly pTooltipWideCssClass = 'p-tooltip-wide';

    constructor(
        private readonly matTooltip: MatTooltip,
        private readonly elementRef: ElementRef<HTMLElement>,
        private readonly renderer: Renderer2
    ) {}

    @HostListener('mouseenter', ['$event'])
    private setTooltipState(): void {
        if (this._disableTooltip) {
            return;
        }

        if (this.showOnlyWhenEllipsis) {
            const element = this.elementRef.nativeElement;
            this.matTooltip.disabled = element.scrollWidth <= element.clientWidth && element.scrollHeight <= element.clientHeight;
        }
    }

    public ngDoCheck(): void {
        this.matTooltip.tooltipClass = getNgClassInputAsString(this.matTooltip.tooltipClass);

        const isWide = this.matTooltip.message?.length > 140;

        const isWideClassAlreadyExist = this.matTooltip.tooltipClass.includes(this.pTooltipWideCssClass);

        const shouldWideClassAdded = isWide && !isWideClassAlreadyExist;

        const shouldWideClassRemoved = !isWide && isWideClassAlreadyExist;

        if (shouldWideClassAdded) {
            this.matTooltip.tooltipClass = this.matTooltip.tooltipClass + ' ' + this.pTooltipWideCssClass;
        } else if (shouldWideClassRemoved) {
            this.matTooltip.tooltipClass = this.matTooltip.tooltipClass.replace(this.pTooltipWideCssClass, '');
        }
    }

    public ngAfterViewInit(): void {
        const position = this.matTooltip.position || 'below';
        const existClasses = this.matTooltip.tooltipClass ? this.matTooltip.tooltipClass : '';
        this.matTooltip.tooltipClass = `${existClasses} p-tooltip ${position}`;
        this.matTooltip.showDelay = this.matTooltip.showDelay || 800;

        if (this.showOnlyWhenEllipsis) {
            const element = this.elementRef.nativeElement;
            this.renderer.setStyle(element, 'text-overflow', 'ellipsis');
            this.renderer.setStyle(element, 'overflow', 'hidden');
            this.renderer.setStyle(element, 'white-space', 'nowrap');
        }
    }
}
